import React, { useState, useContext } from "react";
import { Fab, Paper, Slide, Box, IconButton, Typography } from "@mui/material";
import ChatIcon from '@mui/icons-material/Chat';
import CloseIcon from "@mui/icons-material/Close";
import { VirtualAssistant } from "./VirtualAssistant";
import { ColorsContext } from "../../Context/ColorsContext";

const chatWindowStyle = {
  position: "fixed",
  bottom: 80,
  left: 24,
  width: 400,
  height: "75vh",
  display: "flex",
  flexDirection: "column",
  borderRadius: "16px",
  overflow: "hidden",
  boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
  zIndex: 1210,
  "@media (max-width: 600px)": {
    width: "90%",
    height: "80vh",
    left: "5%",
    bottom: 75,
  },
};

const fabStyle = {
  position: "fixed",
  bottom: 20,
  left: 9,
  zIndex: 1210,
  width: 56,
  height: 56,
};

export default function FloatingChatContainer() {
  const [showChat, setShowChat] = useState(false);
  const { colors } = useContext(ColorsContext);

  return (
    <>
      {/* Floating chat window */}
      <Slide direction="up" in={showChat} mountOnEnter>
        <Paper sx={chatWindowStyle}>
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "10px 16px",
              backgroundColor: colors.navbarColor,
              color: colors.white,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography variant="subtitle1" fontWeight="bold">
                Asistente IA
              </Typography>
            </Box>
            <IconButton
              size="small"
              onClick={() => setShowChat(false)}
              sx={{ color: colors.white }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Chat content */}
          <Box sx={{ flex: 1, overflow: "hidden" }}>
            <VirtualAssistant />
          </Box>
        </Paper>
      </Slide>

      {/* FAB button */}
      <Fab
        onClick={() => setShowChat((prev) => !prev)}
        sx={{
          ...fabStyle,
          backgroundColor: colors.navbarColor,
          color: colors.white,
          "&:hover": {
            backgroundColor: colors.navbarColor,
          },
        }}
        aria-label={showChat ? "Cerrar chat" : "Abrir chat"}
      >
        {showChat ? <CloseIcon /> : <ChatIcon />}
      </Fab>
    </>
  );
}
